import { Highcharts } from "@highcharts/react";

/**
 * Highcharts renders its labels as SVG <text> nodes and writes its own
 * default font-family into them, so CSS on the wrapper never cascades in.
 * Setting it here applies the app font to every chart globally.
 *
 * Imported once from src/index.tsx.
 */
export const CHART_FONT_FAMILY = '"IRANYekanX", "Tahoma", sans-serif';

/**
 * SAMA brand series palette. Highcharts otherwise falls back to its stock
 * 10-colour default (bright cyan/magenta/purple), which clashes badly with
 * the navy + orange scheme. Ordered so the first two series are the two
 * brand marks, then supporting hues that stay in the same tonal family.
 *
 * Kept in sync with `theme.extend.colors` in tailwind.config.js.
 */
export const CHART_COLORS = [
  "#14304D", // primary-80  — catalog header navy
  "#F58220", // secondary-70 — Yoozmeters orange
  "#456181", // primary-60
  "#F8963F", // secondary-60
  "#1F6BB0", // info-70
  "#12A366", // success-70
  "#8B9EB4", // primary-40
  "#DA3B3B", // error-70
  "#5E3AC2", // purple-70
  "#0F2A45", // primary-90
];

/** Neutral chrome shared by axes, grids and plot backgrounds. */
export const CHART_NEUTRALS = {
  axisLine: "#CDD4DC", // gray-30
  gridLine: "#E2E7EC", // gray-20
  label: "#5A6675", // gray-90
  title: "#0F2A45", // primary-90
  track: "#EDF1F5", // primary-10
  tooltipBorder: "#14304D", // primary-80
};

Highcharts.setOptions({
  colors: CHART_COLORS,
  chart: {
    backgroundColor: "transparent",
    style: {
      fontFamily: CHART_FONT_FAMILY,
    },
  },
  title: {
    style: { fontFamily: CHART_FONT_FAMILY },
  },
  subtitle: {
    style: { fontFamily: CHART_FONT_FAMILY },
  },
  tooltip: {
    backgroundColor: "#FFFFFF",
    borderColor: CHART_NEUTRALS.tooltipBorder,
    style: { fontFamily: CHART_FONT_FAMILY, color: CHART_NEUTRALS.title },
  },
  legend: {
    itemStyle: { fontFamily: CHART_FONT_FAMILY, color: CHART_NEUTRALS.label },
    itemHoverStyle: { color: CHART_NEUTRALS.title },
  },
  xAxis: {
    lineColor: CHART_NEUTRALS.axisLine,
    tickColor: CHART_NEUTRALS.axisLine,
    gridLineColor: CHART_NEUTRALS.gridLine,
    labels: {
      style: { fontFamily: CHART_FONT_FAMILY, color: CHART_NEUTRALS.label },
    },
    title: {
      style: { fontFamily: CHART_FONT_FAMILY, color: CHART_NEUTRALS.title },
    },
  },
  yAxis: {
    lineColor: CHART_NEUTRALS.axisLine,
    tickColor: CHART_NEUTRALS.axisLine,
    gridLineColor: CHART_NEUTRALS.gridLine,
    labels: {
      style: { fontFamily: CHART_FONT_FAMILY, color: CHART_NEUTRALS.label },
    },
    title: {
      style: { fontFamily: CHART_FONT_FAMILY, color: CHART_NEUTRALS.title },
    },
  },
});
